import React, { useState, useEffect } from 'react';

interface ProfileEditModalContentProps {
  onClose: () => void;
  fieldType: 'text' | 'textarea';
  initialValue: string;
  onSave: (value: string) => void;
  placeholder?: string;
}

const ProfileEditModalContent: React.FC<ProfileEditModalContentProps> = ({
  onClose,
  fieldType,
  initialValue,
  onSave,
  placeholder
}) => {
  const [value, setValue] = useState(initialValue);

  // Update local state when initialValue changes
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleSave = () => {
    onSave(value);
    onClose();
  };

  return (
    <div className="flex flex-col w-full m-0 p-0">
      {/* Input Field */}
      <div className="flex flex-col w-full" style={{ marginLeft: '24px', marginRight: '24px', maxWidth: 'calc(100% - 48px)', marginBottom: '24px' }}>
        {fieldType === 'textarea' ? (
          <textarea
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={placeholder}
            className="w-full placeholder-white/40 focus:outline-none resize-none"
            style={{
              fontFamily: '"Aeonik TRIAL"',
              fontSize: '16px',
              lineHeight: '20px',
              minHeight: '120px',
              maxWidth: '100%',
              boxSizing: 'border-box',
              borderRadius: '16px',
              border: '1px solid var(--separator, rgba(255, 255, 255, 0.06))',
              background: '#202020',
              padding: '20px',
              color: '#fff'
            }}
          />
        ) : (
          <input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={placeholder}
            className="w-full placeholder-white/40 focus:outline-none"
            style={{
              fontFamily: '"Aeonik TRIAL"',
              fontSize: '16px',
              lineHeight: '20px',
              maxWidth: '100%',
              boxSizing: 'border-box',
              borderRadius: '16px',
              border: '1px solid var(--separator, rgba(255, 255, 255, 0.06))',
              background: '#202020',
              padding: '20px',
              color: '#fff'
            }}
          />
        )}
      </div>
      
      {/* Save Button */}
      <div style={{ marginLeft: '24px', marginRight: '24px', maxWidth: 'calc(100% - 48px)', width: '100%', marginBottom: '24px' }}>
        <button
          onClick={handleSave}
          className="btn btn-secondary w-full"
          style={{ maxWidth: '100%', boxSizing: 'border-box' }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default ProfileEditModalContent; 